<script setup lang="ts">
import tenkoAssociationType from "@/types/responses/getIttenkoAssociation";

const emits = defineEmits(['openDeleteModal'])
const props = defineProps<{
  tenkoAssociation: tenkoAssociationType | undefined,
}>();

</script>
<template>
  <button
    @click="emits('openDeleteModal', props.tenkoAssociation)"
    class="material-symbols-outlined"
    :disabled="!props.tenkoAssociation"
    :style="!props.tenkoAssociation ? 'opacity: 0.5' : ''"
  >
    delete
  </button>
</template>
